import { createStyles, Select } from '@mantine/core'
import { concat, get, keyBy, uniqBy } from 'lodash'
import React, { ReactElement, useMemo, useState } from 'react'

import Icon from '../../components/Icon'
import { useRemoteResults } from './results/useRemoteResults'
import SelectItem from './SelectItem'
import { TAddressSearchItem, TAddressSearchOption } from './types'

type TAddressSearchProps = {
  onAddressSelected: (address: TAddressSearchItem) => void
  lonlat: [number, number]
  useAddressSearchOptions?: (opts: {
    searchValue: string
  }) => TAddressSearchOption[]
  placeholder?: string
}

const useStyle = createStyles((theme) => ({
  wrapper: {
    // boxShadow: theme.shadows.md,
    maxWidth: '700px',
  },
}))

const defaultAddressSearchOptions = (opts: {
  searchValue: string
}): TAddressSearchOption[] => {
  const { searchValue } = opts
  return []
}

export const AddressSearch = (props: TAddressSearchProps): ReactElement => {
  const {
    onAddressSelected,
    lonlat,
    useAddressSearchOptions = defaultAddressSearchOptions,
    placeholder,
  } = props

  const { classes, cx } = useStyle()

  const [searchValue, setSearchValue] = useState('')

  const remoteResults = useRemoteResults({
    text: searchValue,
    lonlat,
  })

  const options = useAddressSearchOptions({ searchValue })

  const [previousResults, setPreviousResults] = useState<
    TAddressSearchOption[]
  >([])

  const data: TAddressSearchOption[] = useMemo(
    () =>
      concat(
        options,
        // remoteResults,
        remoteResults.slice(0, 3),
        previousResults,
      ),
    [options, remoteResults, previousResults],
  )

  // console.log('AddressSearch', {
  //   options,
  //   remoteResults,
  //   searchValue,
  //   previousResults,
  //   data,
  // })

  const onLocationSelected = (value: string): void => {
    const item = get(keyBy(data, 'value'), [value, 'item'])
    setPreviousResults(
      uniqBy(
        [
          {
            value,
            item,
            group: 'Zuletzt verwendet',
          },
          ...previousResults,
        ],
        'value',
      ).slice(0, 3),
    )
    const { lonlat } = item ?? {}
    if (lonlat && onAddressSelected) {
      onAddressSelected(item)
      setTimeout(() => {
        ref.current?.blur()
      }, 0)
    }
  }

  const ref = React.useRef<HTMLInputElement>(null)

  const [value, setValue] = useState(null)

  return (
    <>
      <div className={cx(classes.wrapper)}>
        <Select
          size="md"
          shadow="lg"
          ref={ref}
          placeholder={
            placeholder ||
            i18n.t(`search_addresses_placeholder`, `Suche nach Adressen...`)
          }
          itemComponent={SelectItem}
          data={data}
          searchable
          maxDropdownHeight={500}
          nothingFound={null}
          filter={(value, item) => {
            return true
          }}
          onSelect={(e) => {
            // e.preventDefault()
            // console.log('Item selected', e)
            // setTimeout(() => setSearchValue(''), 100)
          }}
          onSearchChange={setSearchValue}
          onChange={onLocationSelected}
          // value={value?.name1}
          value={null}
          // searchValue={searchValue}

          rightSection={
            <Icon
              size={1.2}
              icon="far fa-search mr-1"
              onClick={() => ref.current?.select()}
            />
          }
          // rightSectifonWidth={30}
          styles={(theme) => ({
            dropdown: {},
            // item: {},
            root: {
              maxWidth: '700px',
              width: '100%',
              // border: '2px solid lime',
              // margin: '0px',
            },
            input: {
              paddingTop: `calc(${theme.spacing.xs} / 3)`,
              paddingBottom: `calc(${theme.spacing.xs} / 3)`,
              // paddingLeft: theme.spacing.xs / 4,
              // paddingRight: theme.spacing.xs / 4,
              height: '40px',
            },
          })}
        />
      </div>
    </>
  )
}
